<template>
  <div>
    <v-dialog v-model="dialog" max-width="650">
      <v-alert
        elevation="2"
        colored-border
        border="bottom"
        type="warning"
        class="mb-0 font-readex py-5"
      >
        <div class="mb-8">Objednávka není dokončená!</div>
        <div class="d-flex justify-space-between">
          <v-btn class="btn btn-red-gradient outlined" id="destroy">Zrušit objednávku</v-btn>
          <v-btn  @click="dialog = false" class="btn btn-green-gradient" id="rest">Pokračovat</v-btn>
        </div>
      </v-alert>
    </v-dialog>
    <CreateOrderForm ref="CreateOrderForm" @preventRedirect="preventRedirect = true"></CreateOrderForm>
  </div>
</template>

<script>
import CreateOrderForm from '@/components/forms/user/CreateOrderForm'
export default {
  name: 'Orders',
  components: { CreateOrderForm },
  data () {
    return {
      preventRedirect: false,
      dialog: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.preventRedirect) {
      this.dialog = true
      setTimeout(() => {
        // console.log(document.getElementById('destroy'))
        const destroy = document.getElementById('destroy')
        destroy.addEventListener('click', () => {
          this.$refs.CreateOrderForm.resetOrderRedirect()
          next()
        })
      }, 50)
    } else {
      // console.log(to)
      next()
    }
  }
}
</script>

<style scoped>

</style>
